module.exports = __webpack_public_path__ + "img/videoporto.ff320cc6.jpg";